import React from 'react';
import DiceLines from '../DiceLines';

export default function ChangingTurnAnimated(props) {
  return <div className="mimic-current-dice-roll">
    <div className="mimic-current-dice-wrap animation-dice-roll-accepted">
      <DiceLines />
    </div>
  </div>;
}
